import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import HeaderComponent from './js/header.component';

ComponentsFactory.getInstance().define('header', HeaderComponent);
